module.exports = __webpack_public_path__ + "static/forecast/fresh-snow/knee-563c6a07c753d44fcc80061a701e0868.svg";